(function ($) {

    $.fn.checkhider = function (options) {
        // build main options before element iteration
        var opts = $.extend({}, $.fn.checkhider.defaults, options);

        return this.each(function () {
            var $this = $(this);

            // build element specific options
            var eOpts = $.metadata ? $.extend({}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend({}, eOpts, $this.dataset()) : eOpts;

            var $div = $('<div/>').addClass('checkHiderButton');
            $this.append($div);

            var $link = $("<span/>").attr('class', 'ui-icon-container-secondary');
            var $iconspan = $("<span/>");
            var $textspan = $("<span/>.").attr('class', 'ui-icon-text');
            $link.append($textspan);
            $link.append($iconspan);
            $div.append($link);
            $link.hide();

            var $checkboxes = $this.find('input:checkbox');

            if ($checkboxes.length > eOpts.hideLongerThan) {

                // Closure to update button state
                var updateButton = function () {
                    if ($checkboxes.not(':visible').length > 0) {  // If there are hidden buttons
                        $textspan.text("+" + $checkboxes.not(':visible').length + "");
                        if(eOpts.hideChecked && $checkboxes.filter(':checked').not(':visible').length > 0) {
                            if($checkboxes.not(':checked').not(':visible').length==0) {
                                $textspan.text($textspan.text() + " (" + translate('all checked') + ")");
                            }
                            else {
                                $textspan.text($textspan.text() + " (" + translate('{0} checked', [$checkboxes.filter(':checked').not(':visible').length]) + ")");
                            }
                        }
                        $iconspan.attr('class', eOpts.expandClass);
                        $link.show();
                    } else {
                        var hideable = eOpts.hideChecked ? $checkboxes.length : $checkboxes.not(':checked').length;
                        if (hideable > (eOpts.hideMin - 1)) { // If there are more unchecked buttons than we're prepared to hide..
                            $textspan.html("&nbsp;");
                            $iconspan.attr('class', eOpts.collapseClass);
                            $link.show();
                        } else { // Otherwise we don't need a button.
                            $textspan.text("");
                            $iconspan.attr('class', '');
                            $link.hide();
                        }
                    }

                    if($.browser.chrome) {
                        // Chrome does not update the location of the right aligned drop down button.
                        // Toggling the position of the link seems to force it to re-render.
                        // The timeout is used to ensure that the position, does actually change (briefly), otherwise this does not work
                        $div.css('position', 'relative');
                        setTimeout(function(){
                            $div.css('position', 'static');
                        }, 0);
                    }

                    // Stalking may need updating if height of checkboxes has changed
                    $(window).trigger('updateStalker');
                    // Recalculate size of waypoint wrapper
                    $this.closest('.sticky-wrapper').children().waypoint('resize');
                };

                // Hide empty checkbox groups
                var updateGroups = function() {
                    $this.find('.form-checkbox-group').each(function(){
                        var $group = $(this);
                        var $checkboxes = $group.nextUntil('.form-checkbox-group').filter(':visible');
                        if($checkboxes.size()==0) {
                            $group.hide();
                        }
                        else {
                            $group.show();
                        }
                    });
                };

                var hideButtons = function () {
                    // Reverse the order so that we hide from the bottom of the list
                    var $hideable = $($checkboxes.not(':checked').get().reverse());
                    if(eOpts.hideChecked) {
                        //  Ensure that $hideable is ordered such that non-checked are hidden before checked
                        $hideable = $($.merge($hideable.get(), $checkboxes.filter(':checked').get().reverse()));
                    }

                    var $hide = $hideable.slice(0, $hideable.size()-eOpts.showFirst);
                    if($hide.size() < eOpts.hideMin) {
                        $checkboxes.closest(eOpts.checkboxParent).show();
                    }
                    else {
                        var $show = $checkboxes.not($hide);
                        $hide.closest(eOpts.checkboxParent).hide();
                        $show.closest(eOpts.checkboxParent).show();
                    }
                    updateGroups();
                    updateButton();
                };

                var showButtons = function () {
                    $checkboxes.closest(eOpts.checkboxParent).show();
                    updateGroups();
                    updateButton();
                };


                // Set initial button state
                if (eOpts.hideChecked || $checkboxes.not(':checked').length > 0) {
                    hideButtons();
                }

                // Do the actual hiding/showing
                $link.click(function () {
                    if ($checkboxes.not(':visible').length > 0) {
                        showButtons();
                    } else {
                        hideButtons();
                    }
                });


                $checkboxes.change(function () {
                    if (!eOpts.hideChecked) {
                        // When the checkboxes are updated by external means (eg using checkAll)
                        // Then any checked checkboxes should be shown
                        var $checkbox = $(this);
                        if ($checkbox.is(':checked')) {
                            $checkbox.closest(eOpts.checkboxParent).show();
                        }
                    }
                    else {
                        if ($checkboxes.not(':visible').length > 0) {
                            hideButtons();
                        }
                    }
                    updateGroups();
                    updateButton();
                });
            }

        });
    };

    $.fn.checkhider.defaults = {
    };


})(jQuery);